import request from "@/libs/request";
import {
  CreateScenarioApprovalsRequest,
  CreateScenarioApprovalsResponse,
  ReadScenarioApprovalsByIdResponse,
  ReadScenarioApprovalsRequest,
  ReadScenarioApprovalsResponse,
  UpdateScenarioApprovalsByIdRequest,
  UpdateScenarioApprovalsByIdResponse,
} from "@/types/scenario-approvals";

// 시나리오 분석 결재 생성
export const createScenarioApprovals = async (
  data: CreateScenarioApprovalsRequest
): Promise<CreateScenarioApprovalsResponse> => {
  const response = await request.post<CreateScenarioApprovalsResponse>(
    `/approvals/create`,
    data
  );
  return response.data;
};

// 시나리오 분석 결재 목록 조회
export const readScenarioApprovals = async (
  data: ReadScenarioApprovalsRequest
): Promise<ReadScenarioApprovalsResponse> => {
  const response = await request.post<ReadScenarioApprovalsResponse>(
    `/approvals/read`,
    data
  );
  return response.data;
};

// 시나리오 분석 결재 조회
export const readScenarioApprovalsById = async ({
  approval_id,
}: {
  approval_id: string;
}): Promise<ReadScenarioApprovalsByIdResponse> => {
  const response = await request.post<ReadScenarioApprovalsByIdResponse>(
    `/approvals/${approval_id}/read`
  );
  return response.data;
};

// 시나리오 분석 결재 승인/반려
export const updateScenarioApprovals = async ({
  approval_id,
  data,
}: {
  approval_id: string;
  data: UpdateScenarioApprovalsByIdRequest;
}): Promise<UpdateScenarioApprovalsByIdResponse> => {
  const response = await request.post<UpdateScenarioApprovalsByIdResponse>(
    `/approvals/${approval_id}/update`,
    data
  );
  return response.data;
};

// 시나리오 분석 결재 삭제(취소)
export const deleteScenarioApprovals = async ({
  approval_id,
}: {
  approval_id: string;
}): Promise<{ deleted_at: number }> => {
  const response = await request.post<{ deleted_at: number }>(
    `/approvals/${approval_id}/cancel`
  );
  return response.data;
};
